import {Account} from "./account";

export class UserInfo {
  role?: string;
  account?: Account;
}
